import type { IconProps } from '../types/IconProps.ts';
export const Sun: IconProps = {
    name: 'Sun',
    children: [
        `<circle cx="12" cy="12" r="4" />`,
        `<path d="M12 4V2M12 20v2M4 12H2M20 12h2M6.5 5.5 5 4M17.5 5.5 19 4M18.5 18.5 20 20M4 20l1.5-1.5" />`,
    ]
};